import React from 'react';
import {
  Checkbox,
  Chip,
  Dialog,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import Slider from 'react-slick';
import styles from '../../../custom/style.module.css';
import notificationStyles from './notification.module.css';
import PDF from '../../../assets/images/pdf.svg';
import { CustomDialogTitle, CustomDialogContent, StyledCard, CustomInputLabel, CustomButton, CustomTextField, InputProps, CustomCheckbox } from '../../../custom/components';
import { CloseIconBtn } from '../../../custom/constants';
import cookies from 'utils/cookies';
import { getAwbDetails } from 'utils/import';
import calculateFees, { getFee } from 'utils/feeCalculator';
import { getLocatDate } from 'utils/converter';
import moment from 'moment';

const NextArrow = (props) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label='Next'
      onClick={onClick}
      className={newClass}
      classes={{ root: notificationStyles.sliderRightArrow }}
    >
      <ArrowRight color='primary' />
    </IconButton>
  );
};

const PrevArrow = (props) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label='Prev'
      onClick={onClick}
      className={newClass}
      classes={{ root: notificationStyles.sliderLeftArrow }}
    >
      <ArrowLeft color='primary' />
    </IconButton>
  );
};

const settings = {
  infinite: false,
  dots: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
  ]
};

const LABELPROPS = {
  minWidth: 200,
  fontSize: 'var(--input-fs)',
  color: 'primary',
};

const DATAPROPS = {
  fontSize: 'var(--input-fs)',
  color: 'primary',
};

const SendNotificationModal = (props) => {
  const awbData = getAwbDetails(props.data);
  const fees = calculateFees(props.data?.fee || [], awbData);
  const { mails, docs, mail_count, mail_footer, mail_temp, mail_cc } = props.data;

  let messageMain = `A shipment consigned to you has arrived at ${cookies.get('station_code')} - ${cookies.get('company_name')}`;
  let message = 'Dear Customer,\n' + messageMain;

  const generateTableRows = (mail_temp, awbData, type) => {
    let storgae_info = null;
    let storage_start = null;
    if (props.data?.fee && props.data.fee.length > 0) {
      let storage = null;
      props.data?.fee.forEach((fee) => {
        fee?.value?.forEach((value) => {
          if (value.unit === 'kg_per_day') {
            storage = value;
          }
        });
      });
      if (storage) {
        storgae_info = getFee(storage, props.data?.fee, awbData, true);
        storage_start = storgae_info?.storage_start || null;
      }
    }
    if (type == 'pdf') {
      message += `\n\nAirwaybill: ${awbData.awb_no}`;
    }
    if (mail_temp && mail_temp?.value) {
      return mail_temp?.value
        ?.map((item, index) => {
          //   if(item.type == 'Text' && item.condition_spl && item.condition_spl != '') {
        //     let condition = item.condition_spl;
        //     let conditionArr = condition.split(',');
        //     let awbArr = awbData?.spl_code ? awbData?.spl_code.split(',') : [];
        //     let isConditionMet = conditionArr.some((cond) => awbArr.includes(cond));
        //     if(isConditionMet) {
        //       return item;
        //     }
        //   }
          if(item.type == 'Text SPL' && item.condition_spl && item.condition_spl != '') {
            let condition = item.condition_spl;
            let conditionArr = condition.split(',');
            let awbArr = awbData?.spl_code ? awbData?.spl_code.split(',') : [];
            let isConditionMet = conditionArr.some((cond) => awbArr.includes(cond));
            if(!isConditionMet) {
              return '';
            }
          }
          let txt = '';
          const itemType = item.type;
          let itemName = item.name || itemType;
          let pcs = awbData.part
            ? `${awbData.pcs} of ${awbData.total_pcs}`
            : awbData.pcs;
          switch (item.type) {
            case 'Text':
            case 'Text SPL':
              txt = type != 'pdf' ? item.value : `${itemName} : ${item.value}`;
              break;
            case 'Hyperlink':
              if (type == 'email') {
                const linkText = item.display_text || item.value;
                txt = `<a href="${item.value}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${linkText}</a>`;
              } else if (type == 'pdf') {
                txt = `${itemName} : ${item.display_text || item.value} (${item.value})`;
              } else {
                txt = <a href={item.value} target='_blank' rel='noopener noreferrer' style={{
                  color: '#1976d2',
                  textDecoration: 'underline' 
                }}>{item.display_text || item.value}</a>;
              }
              break;
            case 'Pieces':
              txt = type != 'pdf' ? pcs : `${itemType}: ${pcs}`;
              break;
            case 'Weight':
              txt = type != 'pdf' ? `${parseFloat(awbData.wgt)?.toFixed(1)}K` : `${itemType}: ${parseFloat(awbData.wgt)?.toFixed(1)}K`;
              break;
            case 'O-D':
              txt = type != 'pdf' ? `${awbData.org}-${awbData.dest}` : `${itemType}: ${awbData.org}-${awbData.dest}`;
              break;
            case 'Flight Number':
              txt = type != 'pdf' ? awbData?.flight_no : `${itemType}: ${awbData?.flight_no}`;
              break;
            case 'Arrival Date':
              txt = type != 'pdf' ? moment(awbData?.flight_arr).format('DD-MMM-YY HH:mm') : `${itemType}: ${moment(awbData?.flight_arr).format('DD-MMM-YY HH:mm')}`;
              break;
            case 'Storage Starts':
              txt = type != 'pdf' ? moment(storage_start).format('DD-MMM-YY') : `${itemType}: ${moment(storage_start).format('DD-MMM-YY')}`;
              break;
            case 'Commodity':
              txt = type != 'pdf' ? awbData?.remark : `${itemType}: ${awbData?.remark}`;
              break;
            case 'Storage Cost': {
              let sValue = storgae_info?.cost_per_unit * storgae_info?.storageUnits;
              //if more than 2 decimal places, show only 2 decimal places
              if (sValue % 1 !== 0) {
                sValue = sValue.toFixed(2);
              }
              if (storgae_info?.min) {
                txt = type != 'pdf' ? `$${storgae_info?.display_min_cost} (Minimum Storage Charges Applicable)` : `Storage Cost Per Day : $${storgae_info?.display_min_cost} (Minimum Storage Charges Applicable)`;
              } else {
                txt = type != 'pdf' ? `$${sValue} (USD ${storgae_info?.cost_per_unit} X ${storgae_info?.storageUnits} KG)` : `Storage Cost Per Day : $${sValue} (USD ${storgae_info?.cost_per_unit} X ${storgae_info?.storageUnits} KG)`;
              }
              break;
            }
          }
          if (itemName == 'Storage Cost') {
            itemName = 'Storage Cost Per Day';
          }
          if (type == 'email') {
            return `<tr key="${index}">
                  <td>
                    <p style="margin: 0;">${itemName}</p>
                  </td>
                  <td>
                    <p style="margin: 0;">: ${txt}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p></p>
                    <p></p>
                  </td>
                </tr>
                `;
          }
          else if (type == 'card') {
            return <Grid container key='index' direction={'row'} flexWrap='wrap' spacing={2}>
              <Grid item xs={6} md={5} lg={5}>
                <Typography {...LABELPROPS}>{itemName}</Typography>
              </Grid>
              <Grid item xs={6} md={7} lg={7}>
                <Typography {...DATAPROPS}>:&nbsp;{txt}</Typography>
              </Grid>
            </Grid>;
          }
          else if (type === 'pdf') {
            return message += `\n${txt}`;
          }
        });
    }
  };

  const generateServiceRows = (fees, type) => {
    if (type == 'pdf') {
      message += `\n\nCharges Due As Of ${getLocatDate('Do MMM YY')}\n -----------`;
      // message += `\n${'Invoice'}: ${props.data?.id}`;
    }
    let totalCost = 0;
    console.log('fees', fees);
    if (fees.services?.length > 0) {
      return fees?.services
        ?.map((service, index) => {
          let msg = '';
          if (service.additional_info && service.additional_info.length > 0) {
            msg += ': ';
            service.additional_info.forEach((info, index) => {
              msg += `${info.chargableDays || 0} Days @ $${info.cost_per_unit} Per Kg`;
              if (index < service.additional_info.length - 1) {
                msg += ', ';
              }
            });
          }
          totalCost += parseFloat(service.cost);
          if (type == 'email') {
            let cost = service.cost;
            if (cost % 1 !== 0) {
              cost = cost.toFixed(2);
            }
            return `<tr key="${index}">
                  <td>
                    <p style="margin: 0;">${service.key + msg}</p>
                  </td>
                  <td>
                    <p style="margin: 0;">: $ ${cost}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p></p>
                    <p></p>
                  </td>
                </tr>
                ${fees?.services.length - 1 == index ? `<tr key="total_due">
                  <td>
                    <p style="margin: 0;">Total Due</p>
                  </td>
                  <td>
                    <p style="margin: 0;">: $ ${totalCost % 1 !== 0 ? totalCost.toFixed(2) : totalCost}</p>
                  </td>
                </tr>` : ''}
                `;
          }
          else if (type == 'card') {
            return <Grid container key='index' direction={'row'} flexWrap='wrap' spacing={2}>
              <Grid item xs={6} md={5} lg={5}>
                <Typography {...LABELPROPS}>{service.key + msg}</Typography>
              </Grid>
              <Grid item xs={6} md={7} lg={7}>
                <Typography {...DATAPROPS}>:&nbsp;${service.cost.toFixed(2)}</Typography>
              </Grid>
              {fees?.services.length - 1 == index ? <Grid item xs={6} md={5} lg={5}>
                <Typography {...LABELPROPS}>Total Due</Typography>
              </Grid> : null}
              {fees?.services.length - 1 == index ? <Grid item xs={6} md={7} lg={7}>
                <Typography {...DATAPROPS}>:&nbsp;${totalCost % 1 !== 0 ? totalCost.toFixed(2) : totalCost}</Typography>
              </Grid> : null}
            </Grid>;
          }
          else if (type === 'pdf') {
            message += `\n${service.key + msg}: $ ${service.cost}`;
            if (fees?.services.length - 1 == index) {
              let tCost = totalCost;
              if (tCost % 1 !== 0) {
                tCost = tCost.toFixed(2);
              }
              message += `\nTotal Due: $ ${tCost}`;
            }
            return message;
          }
        });
    }
  };

  generateTableRows(mail_temp, awbData, 'pdf');
  generateServiceRows(fees, 'pdf');

  const mailBody = `<table
    role="presentation"
    border="0"
    cellPadding="0"
    cellSpacing="0"
    class="btn btn-primary"
  >
    <tbody>
      <tr>
        <td>
          <p>Dear Customer,</p> 
          <p>
           ${messageMain}
          </p> 
        </td>
      </tr>
      <tr>
        <td align="left">
          <table
            role="presentation"
            border="0"
            cellPadding="0"
            cellSpacing="0" 
          >
            <tbody>
            <tr>
                <td>
                  <p></p>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>Airwaybill</td>
                <td>: ${awbData.awb_no}</td>
              </tr>
               <tr>
                <td>
                  <p></p>
                  <p></p>
                </td>
              </tr>
              ${generateTableRows(mail_temp, awbData, 'email').join('')}
              <tr>
                <td>
                  <p></p>
                  <p></p>
                </td>
              </tr>

              <tr>
                <td>
                  <p style="margin: 0;">Charges Due As Of ${getLocatDate('Do MMM YY')}</p>
                  <p style="margin: 0;">—————————</p>
                </td>
              </tr>

              ${generateServiceRows(fees, 'email').join('')}
              <tr>
                <td>
                  <p></p>
                  <p></p>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>`;

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title'
        open={props.modal == 'send_notification'}
        onClose={props.handleClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Send Notification | {awbData.awb_no}
          <CloseIconBtn onClick={props.handleClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <form onSubmit={props.handleSubmitNotification}>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Stack direction='column'>
                  <CustomInputLabel htmlFor='send_to'>To</CustomInputLabel>
                  <Stack direction='row' spacing={2} flexWrap='wrap'>
                    {mails?.map((mail, index) => (
                      <Chip key={index} label={mail.email} size='small' classes={{ label: notificationStyles.chipLabel }} />
                    ))}
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <CustomInputLabel htmlFor='cc' aria-label='Enter cc'>CC</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  variant='outlined'
                  id='cc'
                  fullWidth
                  name='cc'
                  defaultValue={mail_cc && mail_cc?.value ? mail_cc?.value?.cc : ''}
                  disabled={props.showReportModal}
                  className={styles.borderedIpTextfield}
                  InputProps={{
                    classes: {
                      root: styles.borderedIpRoot,
                      input: styles.borderedIp,
                      notchedOutline: styles.notchedOutline,
                      error: styles.errorInput,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInputLabel htmlFor='bcc' aria-label='Enter bcc'>BCC</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  variant='outlined'
                  id='bcc'
                  fullWidth
                  name='bcc'
                  defaultValue={props.data?.mail_bcc && props.data?.mail_bcc?.value ? props.data?.mail_bcc?.value?.bcc : ''}
                  disabled={props.showReportModal}
                  className={styles.borderedIpTextfield}
                  InputProps={{
                    classes: {
                      root: styles.borderedIpRoot,
                      input: styles.borderedIp,
                      notchedOutline: styles.notchedOutline,
                      error: styles.errorInput,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInputLabel htmlFor='subject' aria-label='Enter subject'>Subject</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  id='subject'
                  fullWidth
                  disabled
                  name='subject'
                  value={`${mail_count == 0 ? '1st' : mail_count == 1 ? '2nd' : mail_count == 2 ? '3rd' : (mail_count + 1) + 'th'} Arrival Notification - ${awbData.awb_no} | ${awbData.pcs}Pcs | ${parseFloat(awbData?.wgt || 0)?.toFixed(1)}K | ${awbData.org}-${awbData.dest}`}
                />
              </Grid>
              {/* PDF CONTENT */}
              <Grid item xs={12} sx={{ display: 'none' }}>
                <CustomTextField
                  variant='outlined'
                  multiline
                  rows={30}
                  id='pdf'
                  name='pdf'
                  disabled
                  defaultValue={message}
                />
              </Grid>
              {/* EMAIL CONTENT */}
              <Grid item xs={12} sx={{ display: 'none' }}>
                <CustomTextField
                  variant='outlined'
                  id='message_body'
                  name='message_body'
                  disabled
                  defaultValue={mailBody}
                />
              </Grid>

              <Grid item xs={12}>
                <CustomInputLabel htmlFor='message_body' aria-label='Message body'>Message Body</CustomInputLabel>
                <div className={`${notificationStyles.emailBodyContent}`}>
                  <Typography {...LABELPROPS} mb={2}>Dear Customer,</Typography>
                  <Typography {...LABELPROPS} mb={2}>{messageMain}</Typography>
                  {generateTableRows(mail_temp, awbData, 'card')}
                  <Typography {...LABELPROPS} mt={2}>Charges Due As Of {getLocatDate('Do MMM YY')}</Typography>
                  <Typography {...LABELPROPS}>—————————</Typography>
                  {generateServiceRows(fees, 'card')}
                </div>
              </Grid>

              <Grid item xs={12}>
                <CustomInputLabel htmlFor='message_footer' aria-label='Enter message footer'>Message Footer (Additional Info)</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  variant='outlined'
                  id='message_footer'
                  fullWidth
                  name='message_footer'
                  defaultValue={mail_footer && mail_footer?.value ? mail_footer?.value?.footer : ''}
                  disabled={props.showReportModal}
                  className={styles.borderedIpTextfield}
                  InputProps={{
                    classes: {
                      root: styles.borderedIpRoot,
                      input: styles.borderedIp,
                      notchedOutline: styles.notchedOutline,
                      error: styles.errorInput,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInputLabel>Attachments</CustomInputLabel>
                <StyledCard className={`${styles.modalCard}`}>
                  <Slider {...settings}>
                    {docs?.map((doc, index) => (
                      <div key={index} className={styles.textCenter}>
                        <div className={`${notificationStyles.pdfWrapper}`}>
                          <img src={PDF} alt='pdf' width={'50px'} height={'60px'} />
                          <Typography variant='caption' component={'small'} textAlign={'center'}>{doc.type == 'AWB' ? 'Airwaybill' : doc.name}</Typography>
                        </div>
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'include', }} disableRipple value={doc.id} name='docs' />
                          }
                          label='Include'
                          className={styles.mr0}
                        />
                      </div>
                    ))}
                    {props.data?.notifications?.reverse()?.map((note, index) => (
                      <div key={index} className={styles.textCenter}>
                        <div className={`${notificationStyles.pdfWrapper}`}>
                          <img src={PDF} alt='pdf' width={'50px'} height={'60px'} />
                          <Typography variant='caption' component={'small'} textAlign={'center'}>{index + 1}{index == 0 ? 'st' : index == 1 ? 'nd' : index == 2 ? 'rd' : 'th'} Arrival Notification </Typography>
                        </div>
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'include', }} disableRipple value={note.id} name='notis' />
                          }
                          label='Include'
                          className={styles.mr0}
                        />
                      </div>
                    ))}
                    {(!docs || docs.length == 0) && (!props.data?.notifications || props.data?.notifications.length == 0) && (
                      <Typography variant='body2' color='textSecondary' whiteSpace={'nowrap'}>No Attachments Found</Typography>
                    )}
                  </Slider>
                </StyledCard>
              </Grid>
              <Grid item xs={12} display='flex' justifyContent='flex-end' mt={2}>
                <CustomButton variant='contained' color='primary' type='submit' disabled={props.showReportModal}>Send</CustomButton>
              </Grid>
            </Grid>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
  );
};
export default SendNotificationModal;